// extracted by mini-css-extract-plugin
export default {"modalContainer":"ModalUserInfo_modalContainer__YVabh","title":"ModalUserInfo_title__Kn5N-","buttonContainer":"ModalUserInfo_buttonContainer__R+kkA","btn":"ModalUserInfo_btn__Rcgko"};